import { api360 } from '@api/baseConfig';

import { User } from './userApi.types';

export const getMe = () => api360.get('v1/me').json<User>();
